var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-focus-layout',{staticClass:"error"},[_c('h4',[_vm._v("There was an unexpected error!")]),_c('p',[_vm._v(" Please try to reloading the page. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }